import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'

import styles from './Input.module.scss'

// react-datepicker requires non-stateless functional component
export default class Input extends React.Component {
  static propTypes = {
    children: PropTypes.string,
    className: PropTypes.string,
    icon: PropTypes.string,
    rows: PropTypes.number,
    type: PropTypes.oneOf(['email', 'number', 'password', 'text', 'textarea']),
  }

  static defaultProps = {
    rows: 3,
    type: 'text',
  }

  render() {
    const { children, className, icon, rows, type, ...props } = this.props
    const componentClassName = classNames('Input', styles.this)

    if (type === 'textarea') {
      return (
        <textarea
          {...props}
          rows={rows}
          value={children}
          className={classNames(componentClassName, 'uk-textarea', className)}
        />
      )
    }

    const input = (
      <input
        {...props}
        type={type}
        className={classNames(componentClassName, 'uk-input', className)}
      />
    )

    if (icon) {
      return (
        <div className="uk-inline uk-width-1-1">
          <Icon name={icon} className="uk-form-icon" />
          {input}
        </div>
      )
    }

    return input
  }
}


// WEBPACK FOOTER //
// ./src/components/Input/Input.js